import { render, staticRenderFns } from "./Expert.vue?vue&type=template&id=5692998d&scoped=true"
import script from "./Expert.vue?vue&type=script&lang=ts"
export * from "./Expert.vue?vue&type=script&lang=ts"
import style0 from "./Expert.vue?vue&type=style&index=0&id=5692998d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5692998d",
  null
  
)

export default component.exports